export default __webpack_public_path__ + "static/media/zee_remote_icon.78c3224a.svg";